module.exports = __webpack_public_path__ + "img/1706.806021e8.jpg";